import { render, staticRenderFns } from "./CategoryConfiguratorDivisions.vue?vue&type=template&id=4e7c4312&"
import script from "./CategoryConfiguratorDivisions.vue?vue&type=script&lang=js&"
export * from "./CategoryConfiguratorDivisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports